
define('jst!feature_tour/_header',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="image-block">\n\n  <div class="img space-right">\n    <div class="icon-24 icon-24-compass"> </div>\n  </div>\n\n  <div class="img-ext">\n    <div class="header-title step-count">\n      <%= currentStep %>/<%= totalSteps %>\n    </div>\n  </div>\n\n  <div class="bd">\n    <h3 class="header-title"><%- title %></h3>\n  </div>\n\n</div>\n');
 });

